import React, { Component, createRef } from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaCircleNotch, FaTimes } from 'react-icons/fa';
import { IoMdSend } from 'react-icons/io';
import Link from 'valuelink';
import { Input } from 'valuelink/lib/tags';

import {
  BoldText,
  ButtonText,
  LinkText,
  Text,
} from '../../components/common/Text';
import UploadingComponent from '../../components/common/UploadingComponent';
import {
  setChatInfo,
  resetChat,
  setVideoCallData,
  updateLoginState,
} from '../../actions/index';
import { PrimaryButton } from '../../components/common/Buttons';
import StyledTappable from '../../components/common/StyledTappable';
import UserMessage from '../../components/consultations/chat-bubbles/UserMessage';
import DoctorMessage from '../../components/consultations/chat-bubbles/DoctorMessage';
import {
  SlideTransition,
  FlyInTransition,
} from '../../components/transitions/transitions';
import DoctorProfile from './DoctorProfile';
import { initializeChatClient } from '../../services/chatClient';
import {
  consultSpecialist,
  uploadImageAttachmentChatOnly,
  uploadFileAttachmentChatOnly,
  confirmSlotRequest,
  storeConsultLocation,
  requestUrgentAssistance,
  requestDoctorCall,
  onlineConsultationCheckout,
  fetchSlots,
  bookScheduledConsultation,
  getRefundDetails,
  getTatvaConsultationSummary as getConsultationSummaryAPICall,
} from '../../services';
import Modal from '../common/Modal';
import Contacts from './EmergencyContacts/Contacts';
import ConsultationSummary from './ConsultationSummary';
import { getConsultationSummary as getConsultationSummaryAction } from '../../actions/index';
import LoadingComponent from '../../components/common/LoadingComponent';
import UserImageMessage from '../../components/consultations/chat-bubbles/UserImageMessage';
import DoctorImageMessage from '../../components/consultations/chat-bubbles/DoctorImageMessage';
import ConsultationConfirmedMessage from '../../components/consultations/chat-bubbles/ConsultationConfirmedMessage';
import SpecialistSuggestMessage from '../../components/consultations/chat-bubbles/SpecialistSuggestMessage';
import DoctorFileMessage from '../../components/consultations/chat-bubbles/DoctorFileMessage';
import UserFileMessage from '../../components/consultations/chat-bubbles/UserFileMessage';
import CaseDetailsMessage from '../../components/consultations/chat-bubbles/CaseDetailsMessage';
import ChatInfoMessage from '../../components/consultations/chat-bubbles/ChatInfoMessage';
import DoctorLocationRequestMessage from '../../components/consultations/chat-bubbles/DoctorLocationRequestMessage';
import UrgentAssistanceMessage from '../../components/consultations/chat-bubbles/UrgentAssistanceMessage';
import TypingIndicator from '../../components/consultations/TypingIndicator';
import AddressSearch from '../../containers/common/AddressSearch';
import RefundStatusTele from '../../components/consultations/new-flow/RefundStatusTele';

// service-videocall.svg
import { logEvent } from '../../utils/logEvent';
import { reverseDebounce, fontSize, showError } from '../../utils';
import OfflineAppointmentConfirmedMessage from '../../components/consultations/chat-bubbles/OfflineAppointmentConfirmedMessage';
import DoctorUnavailableMessage from '../../components/consultations/chat-bubbles/DoctorUnavailableMessage';
import VoiceCallMessage from '../../components/consultations/chat-bubbles/VoiceCallMessage';
// import VideoCallMessage from '../../components/consultations/chat-bubbles/VideoCallMessage';
import PrescriptionMessage from '../../components/consultations/chat-bubbles/PrescriptionMessage';
import ConfirmationModal from '../../components/consultations/ConfirmationModal';
import UploadModal from '../../components/consultations/UploadModal';
import ScheduleCardMessage from '../../components/consultations/chat-bubbles/ScheduleCardMessage';
import CalendarModal from '../../components/consultations/CalendarModal';

import arrowBack from '../../images/arrow_back.svg';
import voiceCall from '../../images/voiceCall.svg';
import videoCall from '../../images/videoCall.svg';
import plusIcon from '../../images/consultations/plus-icon.svg';
import morningIcon from '../../images/lab-test/morning.svg';
import afternoonIcon from '../../images/lab-test/afternoon.svg';
import eveningIcon from '../../images/lab-test/evening.svg';
import slotSelected from '../../images/lab-test/tick.svg';
import infoIcon from '../../images/consultations/new-flow/info-icon.svg';
import slotIcon from '../../images/consultations/slotselect-inactive.svg';
import followUpCardIcon from '../../images/consultations/new-flow/follow-up-card-icon.svg';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  z-index: 10;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 20px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const HeaderTopContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0.875rem;
  padding-bottom: 12px;
`;

const BackContainer = styled(StyledTappable)`
  padding-right: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
`;

const HeaderSubtitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SubtitleText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #767787;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderImage = styled.img`
  width: 2.375rem;
  height: 2.375rem;
  border-radius: 12px;
  margin-right: 0.625rem;
`;

const HeaderText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const CallIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  color: #8852cc;
  margin-left: 18px;
  margin-right: 18px;
`;

const HeaderTabsContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  margin-top: 32px;
`;

const FirstMessage = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-self: center;
  width: 90%;
  margin-bottom: 3px;
  color: #0f0b28;
  display: block;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  background: #e2f5ea;
  border-radius: 12px;
  margin-top: 25px;
`;

const HeaderTab = styled(StyledTappable)`
  display: flex;
  align-items: center;
  align-self: stretch;
  flex: 1;
  margin-right: 21px;
  margin-left: 21px;
  border-bottom: ${(props) => (props.active ? '2px solid #ffbb00' : 'none')};
  padding-bottom: 12px;
`;

const HeaderTabText = styled(BoldText)`
  font-style: normal;
  font-weight: ${(props) => (props.active ? '600' : '500')};
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 0.25px;
  color: ${(props) => (props.active ? '#ffbb00' : '#767787')};
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: white;
  padding-bottom: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const RequestStatusContainer = styled.div`
  display: flex;
  max-height: 180px;
  flex-direction: column;
  align-items: stretch;
  box-shadow: 0 -1.7px 7px 0 rgba(0, 0, 0, 0.1);
  background: white;
  padding: 0.75rem;
`;

const StyledUploadingComponent = styled(UploadingComponent)`
  margin: 0;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: stretch;
  z-index: 999;
  background: white;
  padding: 24px 20px 36px 20px;
  border-top: 1px solid #f0f3f6;
`;

const InputTappable1 = styled(StyledTappable)`
  padding: 0 0.5rem;
`;

const InputBox = styled(Input)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  flex: 1 1 0%;
  background-color: #f4f5f6;
  border-radius: 12px;
  line-height: 22px;
  margin-left: 8px;
  padding: 13px 16px;
  ::placeholder {
    color: #75818f;
  }
`;

const SendIcon = styled(IoMdSend)`
  font-size: ${() => `${1.25 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: ${(props) => (props.active ? '#6543C6' : 'rgba(0,0,0,0.5)')};
`;

const StatusContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: stretch;
`;

const StatusBodyContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
`;

const StatusTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: hidden;
`;

const StatusActiveText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #413958;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const StatusBodyText = styled(BoldText)`
  font-size: ${fontSize(1)};
  flex: 1;
`;

const DoctorImage = styled.img`
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 2.75rem;
  margin: ${(props) => props.margin};
`;

const IconTextContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0.25rem 0;
`;

const SlotContainer = styled(StyledTappable)`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
`;

const SlotSelectContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const SlotIcon = styled.img`
  width: 1rem;
  margin-right: 0.625rem;
`;

const DateText = styled(Text)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin-right: 0.5rem;
`;

const TimeText = styled(Text)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const UnavailableText = styled(BoldText)`
  font-weight: 1rem;
  color: #ff704d;
  flex: 1;
`;

const StyledSpecialistSuggestMessage = styled(SpecialistSuggestMessage)`
  margin: 0.5rem -0.375rem 0.5rem -0.375rem;
`;

const StyledLocationRequestMessage = styled(DoctorLocationRequestMessage)`
  margin: 0.5rem -0.375rem 0.5rem -0.375rem;
`;

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  background: rgba(0, 0, 0, 0);
`;

const ProfileModalContainer = styled(ModalContainer)`
  background: white;
  overflow: hidden;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
`;

const LoadingIcon = styled(FaCircleNotch)`
  margin-right: 0.5rem;
`;

const StatusIcon = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.5rem;
  background-color: ${(props) =>
    props.active || props.completed ? '#5EC86C' : '#7F7F7F'};
  opacity: ${(props) => (!props.active && !props.completed ? 0.4 : 1)};
  box-shadow: ${(props) =>
    !props.active && !props.completed
      ? '0 0 0 0.25rem rgba(127, 127, 127, 0.3)'
      : 'none'};
  margin: 0 0.625rem;
  margin-left: 0.25rem;
`;

const StyledLinkText = styled(LinkText)`
  font-size: 12px;
`;

const ConsultationEndedMessage = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  color: #413958;
`;

const CloseContainer = styled(StyledTappable)`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = styled(FaTimes)`
  color: #413958;
`;

class ConsultationChatOnlyContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chatMessage: '',
      loading: false,
      uploading: false,
      uploadProgress: 0,
      requestInfo: {},
      selectedSlot: {},
      modalVisible: false,
      profileVisible: false,
      openProfileId: null,
      fetchMessages: false,
      locationSearchVisible: false,
      showAssistanceConfirmModal: false,
      emergencyContactSkipped: false,
      emergencyContactActive: false,
      emergencyContactMenu: false,
      consultOver: false,
      bookingLabel: '',
      opdLabel: '',
      confirmationModalVoice: false,
      confirmationModalVideo: false,
      showUploadModal: false,
      showCalendar: false,
      showSlots: false,
      followUpDetails: { date: '', time: '' },
      slots: [],
      refundStatusModal: false,
      refundData: {},
      refundLoading: false,
    };
    this.conversationBodyRef = createRef();
    const params = new URLSearchParams(window.location.search);
    const authToken = params.get('authToken');
    const consultationId = params.get('consultationId');

    this.authToken = authToken;
    this.consultationId = consultationId;

    const { dispatch } = this.props;
    dispatch({
      type: 'SET_INITIAL_STATE',
    });
    dispatch({
      type: 'SET_TATVA',
      payload: true,
    });
    dispatch({
      type: 'AUTH_TOKEN',
      payload: authToken,
    });
    dispatch({
      type: 'SET_CONSULTATION_ID',
      payload: consultationId,
    });
    dispatch(updateLoginState('LOGGED_IN'));

    this.locationMessage = 'I have shared my location';
  }
  initPubnub = async (consultationId, channel) => {
    const { userId, chatInfo } = this.props;
    this.chatClient = await initializeChatClient(consultationId);

    this.throttledTypingStatusUpdate = reverseDebounce(() => {
      this.chatClient.setState('USER_TYPING', userId);
      this.timeoutId = setTimeout(() => {
        // send setState to pubnub with status: 'STOP_TYPING'
        this.chatClient.setState('USER_STOP_TYPING', userId);
      }, 2000);
    }, 2000);
    if (chatInfo.chatMessages.length === 0) {
      this.chatClient?.history?.({
        channel,
        count: 20,
      });
    }
    this.chatClient?.subscribe?.(channel);
    this.channelGroup = `visit-usr-group-${this.props.userId}`;
    // this.chatClient?.subscribeForVideo?.(this.channelGroup);
  };
  componentDidMount = () => {
    // GA Tracking
    window.gtag('event', 'screen_view', {
      screen_name: 'Specialist Chat Screen',
    });
    window.addEventListener('keydown', this.handleKeyPress, false);
    this.getConsultationSummaryAPI();
    // Get the status of the request

    logEvent('Online Consultations Chat Screen');
  };

  getSnapshotBeforeUpdate = (prevProps) => {
    const { chatMessages } = this.props.chatInfo;
    const { fetchMessages } = this.state;
    const previousChatMessages = prevProps.chatInfo.chatMessages;
    if (fetchMessages && chatMessages.length > previousChatMessages.length) {
      const list = this.conversationBodyRef.current;
      return list.scrollHeight - list.scrollTop;
    }
    return null;
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (
      prevProps.chatInfo.consultationId !== this.props.chatInfo.consultationId
    ) {
      this.chatClient?.history({
        channel: this.props.chatInfo.chatChannel,
        count: 20,
      });
    }
    if (snapshot) {
      const list = this.conversationBodyRef.current;
      list.scrollTop = list.scrollHeight - snapshot - 50;
      return;
    }
    const { pathname } = this.props.location;
    const { chatMessages, doctorTyping, consultationSummary } =
      this.props.chatInfo;
    if (
      consultationSummary &&
      consultationSummary.consultationInfo?.requestId &&
      !this.pendingRequest
    ) {
      // Request ID is present. Get request status
      this.pendingRequest = true;
      this.requestId = consultationSummary.consultationInfo?.requestId;
    }
    const previousChatMessages = prevProps.chatInfo.chatMessages;
    const prevDoctorTyping = prevProps.chatInfo.doctorTyping;
    if (
      this.conversationBodyRef.current &&
      (chatMessages.length !== previousChatMessages.length ||
        pathname !== prevProps.location.pathname ||
        doctorTyping !== prevDoctorTyping)
    ) {
      this.conversationBodyRef.current.scrollTop =
        this.conversationBodyRef.current.scrollHeight;
    }
  };

  componentWillUnmount = () => {
    const { chatInfo, dispatch } = this.props;
    if (this.chatClient) {
      this.chatClient.unsubscribe(chatInfo.chatChannel);
    }
    dispatch({
      type: 'SET_INITIAL_STATE',
    });
  };

  getConsultationSummaryAPI = async () => {
    try {
      const { dispatch, chatInfo } = this.props;
      const { authToken, consultationId, userId } = this;

      const res = await getConsultationSummaryAPICall(
        consultationId,
        authToken
      );
      if (!res) return;
      const {
        chatChannel,
        doctorName,
        doctorDegrees,
        doctorId,
        profileImg,
        isOver,
        vertical,
        patientName,
        consultDate,
        cancelledAt,
        cancelReason,
        consultTime,
        endedOn,
        bookingType,
        status,
        uuid,
      } = res;
      this.setState({
        doctorVertical: doctorDegrees,
      });
      dispatch(
        setChatInfo({
          consultationId,
          chatChannel: chatChannel,
          chatName: doctorName,
          chatSubtitle: doctorDegrees,
          chatIcon:
            profileImg ??
            `https://api.getvisitapp.com/apiv2/user-images/doctor-${doctorId}.png`,
          receiverId: Number(doctorId),
        })
      );
      this.fromHCP = false;
      this.pendingRequest = isOver === false;
      // this.requestId = requestId;

      dispatch({
        type: 'SET_USER_UUID',
        payload: uuid,
      });

      this.initPubnub(consultationId, chatChannel);

      // dispatch(getConsultationSummaryAction());
    } catch (err) {
      console.error('Error in fetching consultation info ', err);
    }
  };

  hideEmergencyContactModal = () => {
    this.setState({ emergencyContactMenu: false });
  };

  handleKeyPress = (event) => {
    if (event.code === 'Enter') {
      this.sendMessage();
    }
  };

  sendMessage = (message) => {
    if (message) {
      const messagePayload = {
        text: message,
      };
      this.chatClient.publish(messagePayload);
      return;
    }
    const { chatMessage } = this.state;
    if (chatMessage.trim() === '') {
      return;
    }
    const messagePayload = {
      text: chatMessage,
    };
    this.chatClient.publish(messagePayload);
    this.setState({
      chatMessage: '',
    });
  };

  attachFile = () => {
    document.querySelector('#imageAttachment').click();
  };

  handleFileAttachment = () => {
    const { userId, authToken } = this;
    const { consultationId, receiverId } = this.props.chatInfo;
    const file = document.querySelector('#fileAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadFileAttachmentChatOnly(file, consultationId, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
            showUploadModal: false,
          });
        })
        .catch((err) => {
          console.error('Error in uploading file', err);
        });
    }
  };

  handleImageAttachment = () => {
    const { userId, authToken } = this;
    const { consultationId, receiverId } = this.props.chatInfo;
    const file = document.querySelector('#imageAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadImageAttachmentChatOnly(file, consultationId, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
            showUploadModal: false,
          });
        })
        .catch((err) => {
          console.error('Error in uploading image', err);
        });
    }
  };

  onShowOpd = () => {
    const { authToken } = this.props;
    window.location.assign(
      `https://getvisitapp.com/buy-subscription.html?auth=${
        authToken.split(' ')[1]
      }`
    );
  };

  viewSpecialists(consultType, verticalId, bookingInfo) {
    const { history, chatInfo } = this.props;
    history.push('/consultation/specialist-search', {
      onlineFilters: [],
      offlineFilters: [],
      showOnlineAndOffline: false,
      consultationType: consultType,
      verticalId,
      bookingInfo,
      consultRequestInfo: {
        consultationId: chatInfo.consultationId,
      },
    });
  }

  onModalExited = () => {
    this.setState({
      modalVisible: false,
    });
  };

  openProfile = (doctorId, currentList, bookingLabel, opdLabel) => {
    this.setState({
      modalVisible: true,
      profileVisible: true,
      openProfileId: doctorId,
      currentList,
      bookingLabel,
      opdLabel,
    });
  };

  closeProfile = () => {
    this.setState({
      profileVisible: false,
      openProfileId: null,
    });
  };

  fetchMessages() {
    const { chatChannel, chatMessages } = this.props.chatInfo;
    this.chatClient
      .history({
        channel: chatChannel,
        count: 20,
        start: chatMessages[0].timetoken * 10000 - 100,
      })
      .then(() => {
        if (chatMessages.length === this.props.chatInfo.chatMessages.length) {
          // Tried fetching history, found nothing. stop fetching
          this.stopHistoryFetch = true;
        }
        this.setState({
          fetchMessages: false,
        });
      })
      .catch((err) => {
        console.error('Error in fetching messages', err);
      });
  }

  onListScroll = (event) => {
    const { scrollTop } = event.target;
    const { fetchMessages } = this.state;
    if (!this.stopHistoryFetch && scrollTop <= 150) {
      if (!fetchMessages) {
        this.setState({
          fetchMessages: true,
        });
        this.fetchMessages();
      }
    }
  };

  openRequestStatus = () => {
    const { history } = this.props;
    history.push('/consultation/appointment/appointment-status', {
      requestId: this.requestId,
    });
  };

  confirmRequest = () => {
    const { finalCharge } = this.state.requestInfo;
    const { authToken, history } = this.props;
    confirmSlotRequest(
      this.requestId,
      'online',
      finalCharge,
      authToken,
      history
    );
  };

  confirmClinicPayRequest = () => {
    const { finalCharge } = this.state.requestInfo;
    const { authToken, history } = this.props;
    confirmSlotRequest(
      this.requestId,
      'clinic',
      finalCharge,
      authToken,
      history
    );
  };

  detectLocation = () => {
    const options = {
      timeout: 15000,
    };
    const { authToken, chatInfo } = this.props;
    const successCallback = (pos) => {
      const { latitude, longitude } = pos.coords;
      storeConsultLocation(
        latitude,
        longitude,
        chatInfo.consultationId,
        authToken
      )
        .then((res) => {
          this.sendMessage(this.locationMessage);
        })
        .catch((err) => {
          console.error('Error in storing location', err);
        });
    };
    const failureCallback = (err) => {
      console.error('Location failure callback', err);
      this.setState({
        locationFailed: true,
      });
    };
    navigator.geolocation.getCurrentPosition(
      successCallback,
      failureCallback,
      options
    );
  };

  onCloseLocationSearch = () => {
    this.setState({
      locationSearchVisible: false,
    });
  };

  onAddressSelected = (address) => {
    const { authToken, chatInfo } = this.props;
    const latitude = address.location.lat();
    const longitude = address.location.lng();
    storeConsultLocation(
      latitude,
      longitude,
      chatInfo.consultationId,
      authToken
    )
      .then((res) => {
        this.sendMessage(this.locationMessage);
      })
      .catch((err) => {
        showError(err);
        console.error('Error in selecting address', err);
      })
      .finally(() => {
        this.setState({
          locationSearchVisible: false,
        });
      });
  };

  searchLocation = () => {
    this.setState({ locationSearchVisible: true, modalVisible: true });
  };

  onUrgentAssistanceClicked = () => {
    const { authToken, chatInfo } = this.props;
    requestUrgentAssistance(chatInfo.consultationId, authToken)
      .then(() => {
        this.setState({
          showAssistanceConfirmModal: true,
        });
      })
      .catch((err) => {
        console.error('Error in requesting urgent assistance', err);
      });
  };

  requestCall = (callType = 'voice') => {
    if (callType === 'voice') {
      logEvent('Online Consultation Voice Call Selection');
    } else {
      logEvent('Online Consultations Video Call Selection');
    }
    const { authToken, chatInfo } = this.props;
    requestDoctorCall(chatInfo.consultationId, callType, authToken)
      .then((res) => {
        this.hideModal();
      })
      .catch((err) => {
        this.hideModal();
        console.error('Error in requesting video call', err);
      });
  };

  initiateVideoCall = (sessionDetails) => {
    const { authToken } = this.props;
    if (window.Android !== undefined && window.Android.initiateVideoCall) {
      window.Android.initiateVideoCall(
        Number(sessionDetails.sessionId),
        Number(sessionDetails.consultationId),
        authToken
      );
    } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
      window.webkit.messageHandlers.visitIosView.postMessage(
        JSON.stringify({
          method: 'startVideoCall',
          roomName: sessionDetails.roomName,
          token: sessionDetails.token,
          doctorName: sessionDetails.doctorName,
          profileImg: sessionDetails.doctorProfileImage,
        })
      );
    } else {
      const { dispatch } = this.props;
      sessionDetails.authToken = authToken;
      sessionDetails.startCall = true;
      dispatch(setVideoCallData(sessionDetails));
    }
  };

  hideModal = () => {
    this.setState({
      confirmationModalVideo: false,
      confirmationModalVoice: false,
    });
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      showUploadOption: false,
    });
    setTimeout(this.props.hideModal, 200);
  };
  render() {
    const { history, chatInfo, location, authToken } = this.props;
    const { consultationSummary } = chatInfo;
    const consultationInfo = consultationSummary?.consultationInfo || {};
    const {
      chatMessage,
      currentList,
      uploading,
      uploadProgress,
      requestInfo,
      modalVisible,
      profileVisible,
      openProfileId,
      fetchMessages,
      locationSearchVisible,
      showAssistanceConfirmModal,
      bookingLabel,
      opdLabel,
      showUploadModal,
      showCalendar,
      refundStatusModal,
      showSlots,
      confirmationModalVoice,
      confirmationModalVideo,
      consultOver,
      emergencyContactMenu,
      emergencyContactActive,
      emergencyContactSkipped,
      followUpDetails,
      doctorVertical,
      slots,
      refundData,
      refundLoading,
    } = this.state;

    const { doctorName, currentStatus, slotsConfirmed, profilePicUrl } =
      requestInfo;
    const chatMessageLink = Link.state(this, 'chatMessage').onChange((val) => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      const { userId } = this;
      // send setState to pubnub with status: 'TYPING'
      if (val !== '') {
        this.throttledTypingStatusUpdate();
      } else {
        // send setState to pubnub with status: 'STOP_TYPING'
        this.chatClient.setState('USER_STOP_TYPING', userId);
      }
    });

    const renderUserMessage = (ele) => {
      switch (ele.cardType) {
        case 'text':
          return (
            <UserMessage
              key={ele.messageId}
              message={ele.text}
              timestamp={ele.timetoken}
            />
          );
        case 'chatImage':
          return (
            <UserImageMessage
              key={ele.messageId}
              messageId={ele.messageId}
              filePreviewUrl={ele.filePreviewUrl}
              url={ele.url}
              timestamp={ele.timetoken}
            />
          );
        case 'documentCard':
          return (
            <UserFileMessage
              fileName={ele.documentFileName}
              url={ele.documentUrl}
              messageId={ele.messageId}
              key={ele.messageId}
              timestamp={ele.timetoken}
            />
          );
        case 'connectionRequest':
          return <VoiceCallMessage key={ele.messageId} message={ele.text} />;
        case 'reschedule-card':
          return (
            <ScheduleCardMessage
              key={ele.messageId}
              cardDetails={ele}
              consultationId={this.props.chatInfo.consultationId}
            />
          );
        default:
          return false;
      }
    };
    const renderDoctorMessage = (ele) => {
      switch (ele.cardType) {
        case 'text':
          return (
            <DoctorMessage
              doctorImage={chatInfo.chatIcon}
              doctorName={ele.name}
              key={ele.messageId}
              message={ele.text}
              timestamp={ele.timetoken}
            />
          );
        case 'case-summary':
          return (
            <CaseDetailsMessage
              key={ele.messageId}
              caseDetails={ele.caseDetails}
            />
          );
        case 'chatImage':
          return (
            <DoctorImageMessage
              key={ele.messageId}
              messageId={ele.messageId}
              filePreviewUrl={ele.filePreviewUrl}
              url={ele.url}
              timestamp={ele.timetoken}
            />
          );
        case 'documentCard':
          return (
            <DoctorFileMessage
              fileName={ele.documentFileName}
              doctorImage={`https://api.getvisitapp.com/apiv2/user-images/doctor-${ele.senderId}.png`}
              url={ele.documentUrl}
              messageId={ele.messageId}
              key={ele.messageId}
              timestamp={ele.timetoken}
            />
          );
        case 'treatmentPlanCard':
          return (
            <PrescriptionMessage
              key={ele.messageId}
              medicines={ele.medicines}
              labTests={ele.labs}
              prescriptionLink={ele.prescriptionLink}
              prescriptionId={ele.prescriptionId}
              outsideClick={this.handleOutsideClick}
            />
          );
        case 'sp-suggest': {
          const consultType =
            ele.searchType === 'clinic' ? 'offline' : 'online';
          return (
            <StyledSpecialistSuggestMessage
              key={ele.messageId}
              onSpecialistCardTapped={this.openProfile}
              onBookTapped={this.bookDoctor}
              onShowOpdTapped={this.onShowOpd}
              onSeeSpecialistsTapped={() =>
                this.viewSpecialists(
                  consultType,
                  ele.verticalId,
                  ele.bookingInfo
                )
              }
              titleText={ele.text}
              specialists={ele.topCard}
              consultType={consultType}
              footerIcon={ele.bottomCard.images[0]}
              footerIcons={ele.bottomCard.images}
              footerTitle={ele.bottomCard.topLabel}
              footerText={ele.bottomCard.bottomLabel}
              opdLabel={ele.bookingInfo[consultType].opdLabel}
              bookingLabel={ele.bookingInfo[consultType].bookingLabel}
            />
          );
        }

        // case 'video-card':
        //   return (
        //     <VideoCallMessage
        //       sessionId={ele.sessionId}
        //       consultationId={ele.consultationId}
        //       callStartAt={ele.callStartAt}
        //       doctorName={ele.doctorName}
        //       patientName={ele.patientName}
        //       doctorImg={ele.doctorImg}
        //       initiateVideoCall={this.initiateVideoCall}
        //       callStatus={ele.callStatus}
        //     />
        //   );
        case 'reschedule-card':
          return (
            <ScheduleCardMessage
              key={ele.messageId}
              cardDetails={ele}
              consultationId={this.props.chatInfo.consultationId}
            />
          );
        default:
          return false;
      }
    };
    const renderBotMessage = (ele) => {
      switch (ele.cardType) {
        case 'consult-confirm':
          return (
            <ConsultationConfirmedMessage
              key={ele.messageId}
              heading={ele.text}
              title={ele.topLabel}
              profileImg={ele.profileImg}
              subTitle={ele.bottomLabel}
            />
          );
        case 'offline-confirm':
          return (
            <OfflineAppointmentConfirmedMessage
              key={ele.messageId}
              timetoken={ele.consultationInfo.appointmentDate}
              doctorName={ele.consultationInfo.doctorName}
              vertical={ele.consultationInfo.vertical || doctorVertical}
              orgName={ele.consultationInfo.orgName}
              latitude={ele.consultationInfo.latitude}
              longitude={ele.consultationInfo.longitude}
              orgAddress={ele.consultationInfo.orgAddress}
              profileImage={ele.consultationInfo.profileImg}
              appointmentTime={ele.consultationInfo.appointmentTime}
              timingsIcon={ele.consultationInfo.timingsIcon}
              clinicPayment={ele.consultationInfo.clinicPayment}
              onTap={this.openRequestStatus}
            />
          );
        case 'info':
          return <ChatInfoMessage key={ele.messageId} message={ele.text} />;
        case 'location-request':
          return (
            <StyledLocationRequestMessage
              key={ele.messageId}
              topLabel={ele.topLabel}
              onDetectLocation={this.detectLocation}
              onSearchLocation={this.searchLocation}
            />
          );
        case 'urgentAssistance':
          return (
            <UrgentAssistanceMessage
              key={ele.messageId}
              text={ele.text}
              onUrgentAssistanceClicked={this.onUrgentAssistanceClicked}
              showConfirmed={showAssistanceConfirmModal}
            />
          );
        default:
          return false;
      }
    };
    const renderChatMessage = (ele) => {
      switch (ele.userType) {
        case 'patient':
          return renderUserMessage(ele);
        case 'doctor':
          return renderDoctorMessage(ele);
        case 'bot':
          return renderBotMessage(ele);
        default:
          return renderUserMessage(ele);
      }
    };
    const renderCurrentStatus = () => {
      switch (currentStatus) {
        case 'initiated': {
          return (
            <StatusContainer>
              <StatusTextContainer>
                <IconTextContainer>
                  <DoctorImage src={profilePicUrl} margin="0 0.4rem 0 0" />
                  <StatusTextContainer>
                    <IconTextContainer>
                      <IconTextContainer>
                        <StatusIcon active />
                        <div className="txt-mblack-600-12">
                          Confirming your appointment
                        </div>
                      </IconTextContainer>
                      <StatusActiveText>{doctorName}</StatusActiveText>
                    </IconTextContainer>
                  </StatusTextContainer>
                  <StyledTappable onTap={this.openRequestStatus}>
                    <StyledLinkText>Details</StyledLinkText>
                  </StyledTappable>
                </IconTextContainer>
              </StatusTextContainer>
            </StatusContainer>
          );
        }
        case 'confirmed': {
          const slot = slotsConfirmed[0].slots[0];
          const slotDate = slotsConfirmed[0].date;
          return (
            <StatusContainer>
              <StatusBodyContainer>
                <StatusTextContainer>
                  <IconTextContainer>
                    <StatusIcon active />
                    <StatusActiveText>Timing Confirmed</StatusActiveText>
                  </IconTextContainer>
                  <IconTextContainer>
                    <StatusBodyText>{`${doctorName} is available to take up your appointment at`}</StatusBodyText>
                    <DoctorImage src={profilePicUrl} margin="0 0 0 0.4rem" />
                  </IconTextContainer>
                  {slot && (
                    <SlotContainer>
                      <SlotSelectContainer>
                        <SlotIcon src={slot.icon} />
                        <DateText>{slotDate}</DateText>
                        <TimeText>{`(${slot.timings})`}</TimeText>
                      </SlotSelectContainer>
                    </SlotContainer>
                  )}
                  <IconTextContainer>
                    <StyledTappable onTap={this.openRequestStatus}>
                      <StyledLinkText>See Details</StyledLinkText>
                    </StyledTappable>
                  </IconTextContainer>
                </StatusTextContainer>
              </StatusBodyContainer>
            </StatusContainer>
          );
        }
        case 'reschedule':
          return (
            <StatusContainer>
              <StatusBodyContainer>
                <StatusTextContainer>
                  <IconTextContainer>
                    <StatusIcon active />
                    <StatusActiveText>Appointment Timings</StatusActiveText>
                  </IconTextContainer>
                  <IconTextContainer>
                    <UnavailableText>{`Sorry, ${doctorName} is not available at your selected time slots.`}</UnavailableText>
                    <DoctorImage src={profilePicUrl} margin="0 0 0 0.4rem" />
                  </IconTextContainer>
                  <IconTextContainer>
                    <StyledTappable onTap={this.openRequestStatus}>
                      <StyledLinkText>
                        Click to see alternate timings
                      </StyledLinkText>
                    </StyledTappable>
                  </IconTextContainer>
                </StatusTextContainer>
              </StatusBodyContainer>
            </StatusContainer>
          );
        case 'booked':
          return false;
        case 'cancelled':
          return false;
        default:
          return false;
      }
    };

    const renderTopHeading = () => {
      if (!chatInfo?.chatName) return <></>;
      return (
        <FirstMessage>{chatInfo?.chatName} will be joining chat</FirstMessage>
      );
    };
    const consultationIsOver =
      consultationSummary?.consultationInfo?.isOver ||
      currentStatus === 'cancelled' ||
      consultationSummary?.reschedule;
    const ConversationBody = () =>
      false ? (
        <LoadingComponent />
      ) : (
        <>
          <BodyContainer
            ref={this.conversationBodyRef}
            onScroll={this.onListScroll}
          >
            {fetchMessages && (
              <LoadingContainer>
                <LoadingIcon className="icon-spin" />
                <Text>Fetching Messages...</Text>
              </LoadingContainer>
            )}
            {((consultationSummary &&
              consultationSummary.consultationInfo?.isOver) ||
              currentStatus !== 'cancelled') &&
              renderTopHeading()}
            {chatInfo.chatMessages.map(renderChatMessage)}
            {/* {consultationSummary &&
              consultationSummary.consultationInfo.isOver && (
                <div
                  className="flex flex-col justify-center items-center p-16px border border-txtsecondary-shades7 ml-28px rounded-12 mt-16px"
                  style={{ maxWidth: '80%' }}
                >
                  <div className="flex items-center">
                    <img src={infoIcon} alt="info" className="self-start" />
                    <p className="text-body-s text-txtlight font-medium ml-10px">
                      Need to do a follow-up consult with your doctor? Click
                      here to schedule a follow-up
                    </p>
                  </div>
                  <button
                    className="flex justify-center items-center border border-primary w-full mt-16px py-12px rounded-8"
                    onClick={() => this.fetchSlots()}
                  >
                    <img src={followUpCardIcon} alt="calendar" />
                    <p className="ml-10px text-body-s font-semibold text-txtlight">
                      Schedule a Follow-up
                    </p>
                  </button>
                </div>
              )} */}

            {currentStatus === 'cancelled' && (
              <div className="chat-cancelled-msg">
                You cancelled your appointment with {doctorName}
              </div>
            )}
            <FlyInTransition
              in={this.props.chatInfo.doctorTyping}
              mountOnEnter
              unmountOnExit
              appear
            >
              <TypingIndicator doctorImage={chatInfo?.chatIcon} />
            </FlyInTransition>
          </BodyContainer>
          {this.pendingRequest &&
            currentStatus &&
            currentStatus !== 'cancelled' && (
              <RequestStatusContainer>
                {renderCurrentStatus()}
              </RequestStatusContainer>
            )}
          {/* {consultationSummary &&
            !consultationSummary.serviceTimings.available && (
              <DoctorUnavailableMessage
                label={consultationSummary.serviceTimings.label}
              />
            )} */}
          {/* {consultationSummary &&
          (consultationSummary.consultationInfo.isOver ||
            currentStatus === 'cancelled' ||
            consultationSummary.reschedule) ? (
            <RequestStatusContainer>
              <StatusContainer>
                <StatusBodyContainer>
                  <StatusTextContainer>
                    <ConsultationEndedMessage>
                      {consultationSummary.reschedule
                        ? 'Your Consultation has been rescheduled'
                        : `Your consultation with ${chatInfo.chatName} has ended`}
                    </ConsultationEndedMessage>
                    <PrimaryButton onTap={this.onlineConsultationCheckout}>
                      <ButtonText>Book Another Consultation</ButtonText>
                    </PrimaryButton>
                    {location?.state?.trackRefund === 1 && (
                      <>
                        <div
                          className="border m-6"
                          style={{ color: '#F0F3F6' }}
                        />
                        <div className="flex justify-center items-center pb-4">
                          <p
                            className="font-semibold text-caption-l text-center cursor-pointer"
                            style={{ color: '#ffbb00' }}
                            onClick={this.showRefundStatusModal}
                          >
                            Track refund status
                          </p>
                        </div>
                      </>
                    )}
                  </StatusTextContainer>
                </StatusBodyContainer>
              </StatusContainer>
            </RequestStatusContainer>
          ) : ( */}
          {this.props.chatInfo?.chatChannel && (
            <InputContainer>
              <input
                type="file"
                id="imageAttachment"
                accept="image/*,application/pdf,.pdf"
                style={{ display: 'none' }}
                onChange={this.handleImageAttachment}
              />
              <input
                type="file"
                id="fileAttachment"
                accept=".pdf"
                style={{ display: 'none' }}
                onChange={this.handleFileAttachment}
              />

              {/* <img onClick={this.attachFile} src={link} /> */}
              {!consultationIsOver && (
                <img
                  onClick={() => this.setState({ showUploadModal: true })}
                  src={plusIcon}
                  alt=""
                />
              )}

              <div className="flex flex-1">
                <InputBox
                  disabled={consultationIsOver}
                  valueLink={chatMessageLink}
                  placeholder={
                    consultationIsOver
                      ? 'Consultation Over'
                      : `Type your message here`
                  }
                  onKeyDown={this.handleKeyPress}
                />
                {!consultationIsOver && (
                  <InputTappable1
                    onTap={this.sendMessage}
                    disabled={chatMessage.trim().length === 0}
                  >
                    <SendIcon active={chatMessage.trim().length !== 0} />
                  </InputTappable1>
                )}
              </div>
            </InputContainer>
          )}
          {/* )} */}
        </>
      );
    const closeView = () => {
      if (typeof window.Android !== 'undefined') {
        window.Android.closeView();
        window.Android.closeView(true);
      } else if (window.ReactNativeWebView) {
        window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else if (window.webkit?.messageHandlers.visitIosView) {
        window?.webkit?.messageHandlers?.visitIosView?.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else {
        this.props.history.push('/home');
      }
    };
    return (
      <OuterContainer>
        <HeaderContainer>
          <HeaderTopContainer>
            <BackContainer onTap={closeView}>
              <img src={arrowBack} alt="" />
            </BackContainer>
            <HeaderImage src={chatInfo.chatIcon} />
            <HeaderTextContainer>
              <HeaderTitleContainer>
                <HeaderText>{chatInfo.chatName}</HeaderText>
              </HeaderTitleContainer>
              <HeaderSubtitleContainer>
                <SubtitleText>{chatInfo.chatSubtitle}</SubtitleText>
              </HeaderSubtitleContainer>
            </HeaderTextContainer>
            {!consultOver &&
              emergencyContactMenu &&
              !emergencyContactActive &&
              !emergencyContactSkipped && (
                <Contacts
                  information={this.props}
                  authToken={authToken}
                  hideModal={this.hideEmergencyContactModal}
                />
              )}
            {/* {consultationSummary &&
              !consultationInfo?.isOver &&
              consultationInfo.services?.indexOf('voice') !== -1 &&
              !this.fromHCP && (
                <StyledTappable
                  onTap={() => {
                    this.setState({
                      confirmationModalVideo: false,
                      confirmationModalVoice: true,
                    });
                  }}
                >
                  <CallIcon src={voiceCall} />
                </StyledTappable>
              )} */}
            {consultationSummary &&
              !consultationInfo?.isOver &&
              consultationInfo?.services?.indexOf('video') !== -1 && (
                <div
                  style={{
                    border: '1px solid #F0F3F6',
                    height: '10.5px',
                    width: '0.5px',
                    alignSelf: 'center',
                    backgroundColor: '#F0F3F6',
                  }}
                />
              )}
            {/* {consultationSummary &&
              !consultationSummary?.consultationInfo?.isOver &&
              consultationSummary?.consultationInfo?.services.indexOf(
                'video'
              ) !== -1 &&
              !this.fromHCP && (
                <StyledTappable
                  onTap={() => {
                    this.setState({
                      confirmationModalVideo: true,
                      confirmationModalVoice: false,
                    });
                  }}
                >
                  <CallIcon src={videoCall} />
                </StyledTappable>
              )} */}
          </HeaderTopContainer>
        </HeaderContainer>
        {uploading && (
          <StyledUploadingComponent
            uploadProgress={`${uploadProgress}%`}
            borderRadius={0}
          />
        )}
        {/* <Switch>
          <Route
            path="/consultation/chat"
            exact
            render={() => ConversationBody()}
          />
          <Route
            path="/consultation/chat/summary"
            component={ConsultationSummary}
          />
        </Switch> */}
        {ConversationBody()}
        {modalVisible && (
          <Modal>
            <ModalContainer>
              <FlyInTransition
                in={locationSearchVisible}
                mountOnEnter
                unmountOnExit
                onExited={this.onModalExited}
                appear
              >
                <AddressSearch
                  onAddressSelect={this.onAddressSelected}
                  onClose={this.onCloseLocationSearch}
                />
              </FlyInTransition>
              <SlideTransition
                in={profileVisible}
                mountOnEnter
                unmounOnExit
                onExited={this.onModalExited}
                appear
                classNames="slide-in"
              >
                <ProfileModalContainer>
                  <DoctorProfile
                    doctorId={openProfileId}
                    currentList={currentList}
                    closeProfile={this.closeProfile}
                    bookDoctor={this.bookDoctor}
                    onShowOpd={this.onShowOpd}
                    bookingLabel={bookingLabel}
                    opdLabel={opdLabel}
                    footer={true}
                  />
                </ProfileModalContainer>
              </SlideTransition>
            </ModalContainer>
          </Modal>
        )}
        {confirmationModalVideo && (
          <ConfirmationModal
            callType="video"
            message={'Do you want to request for a video call?'}
            hideModal={this.hideModal}
            requestCall={() => {
              this.requestCall('video');
            }}
          />
        )}
        {confirmationModalVoice && (
          <ConfirmationModal
            callType="voice"
            message={'Do you want to request for a voice call?'}
            hideModal={this.hideModal}
            requestCall={() => {
              this.requestCall('voice');
            }}
          />
        )}
        {showUploadModal && (
          <UploadModal
            hideModal={() => this.setState({ showUploadModal: false })}
            handleAttachment={(type) => {
              if (type === 'follow') {
                this.fetchSlots();
              } else this.attachFile();
            }}
            fromHCP={this.fromHCP}
            hideBookAnother={true}
            hideCamera={true}
          />
        )}
        {showCalendar && (
          <CalendarModal
            hideModal={() => this.setState({ showCalendar: false })}
            onDateSelection={this.onDateSelection}
            selectedDate={(date) =>
              this.setState((prev) => ({
                followUpDetails: { ...prev.followUpDetails, date: date },
              }))
            }
            slots={slots}
          />
        )}
        {refundStatusModal && (
          <RefundStatusTele
            closeModal={() => this.closeRefundStatusModal()}
            refundData={refundData}
            refundLoading={refundLoading}
          />
        )}
        {showSlots && (
          <Modal>
            <div
              className="modalContainer"
              onClick={(e) => {
                // ignore clicks on the component itself
                if (this.node && this.node.contains(e.target)) {
                  return;
                }
                if (followUpDetails.time) this.setState({ showSlots: false });
                else
                  this.setState({
                    showSlots: false,
                    selectedAppointmentTime: 'now',
                  });
              }}
            >
              <FlyInTransition
                in={showSlots}
                mountOnEnter
                unmountOnExit
                onExited={() => this.setState({ showSlots: false })}
                appear
              >
                <div className="modalBody" ref={(node) => (this.node = node)}>
                  <div className="modalHeader">
                    <div className="flex flex-row items-center">
                      <img src={slotIcon} alt="" />
                      <p className="ml-10px text-body-l text-txtlight-new font-semibold">
                        Choose Appointment Time
                      </p>
                    </div>
                    <CloseContainer
                      onTap={() =>
                        followUpDetails.time
                          ? this.setState({ showSlots: false })
                          : this.setState({
                              showSlots: false,
                              selectedAppointmentTime: 'now',
                            })
                      }
                    >
                      <CloseIcon />
                    </CloseContainer>
                  </div>
                  <div className="modalDetails slots">
                    {slots
                      .filter((s) => {
                        return s.date === followUpDetails.date;
                      })
                      .map((t) => {
                        let morningSlot = [];
                        let afternoonSlot = [];
                        let eveningSlot = [];
                        if (t.slots) {
                          morningSlot = t.slots.filter((slot) => {
                            return Number(slot.substring(0, 2)) < 12;
                          });
                          afternoonSlot = t.slots.filter((slot) => {
                            return (
                              Number(slot.substring(0, 2)) >= 12 &&
                              Number(slot.substring(0, 2)) <= 16
                            );
                          });
                          eveningSlot = t.slots.filter((slot) => {
                            return Number(slot.substring(0, 2)) > 16;
                          });
                        }
                        return (
                          <>
                            {morningSlot.length > 0 && (
                              <div className="">
                                <div className="flex flex-row items-center">
                                  <img src={morningIcon} alt="" />
                                  <p className="ml-4px text-body-s text-txtlight font-medium">
                                    Morning
                                  </p>
                                </div>
                                <div className="flex-row-wrap">
                                  {morningSlot.map((t, index) => {
                                    return (
                                      <div
                                        className={
                                          followUpDetails.time === t
                                            ? 'slot-time selected-slot-time flex flex-row items-center justify-center'
                                            : 'slot-time unselected-slot-time flex flex-row items-center justify-center'
                                        }
                                        style={{
                                          width: '70px',
                                          height: '32px',
                                        }}
                                        key={index}
                                        onClick={() => {
                                          this.setState((prev) => ({
                                            followUpDetails: {
                                              ...prev.followUpDetails,
                                              time: t,
                                            },
                                          }));
                                          var objDiv =
                                            document.getElementsByClassName(
                                              'slots'
                                            );

                                          if (objDiv && objDiv.length > 0) {
                                            objDiv[0].scrollTop =
                                              objDiv[0].scrollHeight;
                                          }
                                        }}
                                      >
                                        {followUpDetails.time !== t ? (
                                          <span className="txt-600-12">
                                            {t}
                                          </span>
                                        ) : (
                                          <div className="flex flex-row items-center justify-center">
                                            <img src={slotSelected} alt="" />
                                            <span className="ml-8px txt-600-12">
                                              {t}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                            {afternoonSlot.length > 0 && (
                              <div className="mt-24px">
                                <div className="flex flex-row items-center">
                                  <img src={afternoonIcon} alt="" />
                                  <p className="ml-4px text-body-s text-txtlight font-medium">
                                    afternoon
                                  </p>
                                </div>
                                <div className="flex-row-wrap">
                                  {afternoonSlot.map((t, index) => {
                                    return (
                                      <div
                                        className={
                                          followUpDetails.time === t
                                            ? 'slot-time selected-slot-time flex flex-row items-center justify-center'
                                            : 'slot-time unselected-slot-time flex flex-row items-center justify-center'
                                        }
                                        style={{
                                          width: '70px',
                                          height: '32px',
                                        }}
                                        key={index}
                                        onClick={() => {
                                          this.setState((prev) => ({
                                            followUpDetails: {
                                              ...prev.followUpDetails,
                                              time: t,
                                            },
                                          }));
                                          var objDiv =
                                            document.getElementsByClassName(
                                              'slots'
                                            );

                                          if (objDiv && objDiv.length > 0) {
                                            objDiv[0].scrollTop =
                                              objDiv[0].scrollHeight;
                                          }
                                        }}
                                      >
                                        {followUpDetails.time !== t ? (
                                          <span className="txt-600-12">
                                            {t}
                                          </span>
                                        ) : (
                                          <div className="flex flex-row items-center justify-center">
                                            <img src={slotSelected} alt="" />
                                            <span className="ml-8px txt-600-12">
                                              {t}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                            {eveningSlot.length > 0 && (
                              <div className="mt-24px">
                                <div className="flex flex-row items-center">
                                  <img src={eveningIcon} alt="" />
                                  <p className="ml-4px text-body-s text-txtlight font-medium">
                                    Evening
                                  </p>
                                </div>
                                <div className="flex-row-wrap">
                                  {eveningSlot.map((t, index) => {
                                    return (
                                      <div
                                        className={
                                          followUpDetails.time === t
                                            ? 'slot-time selected-slot-time flex flex-row items-center justify-center'
                                            : 'slot-time unselected-slot-time flex flex-row items-center justify-center'
                                        }
                                        style={{
                                          width: '70px',
                                          height: '32px',
                                        }}
                                        key={index}
                                        onClick={() => {
                                          this.setState((prev) => ({
                                            followUpDetails: {
                                              ...prev.followUpDetails,
                                              time: t,
                                            },
                                          }));
                                          var objDiv =
                                            document.getElementsByClassName(
                                              'slots'
                                            );

                                          if (objDiv && objDiv.length > 0) {
                                            objDiv[0].scrollTop =
                                              objDiv[0].scrollHeight;
                                          }
                                        }}
                                      >
                                        {followUpDetails.time !== t ? (
                                          <span className="txt-600-12">
                                            {t}
                                          </span>
                                        ) : (
                                          <div className="flex flex-row items-center justify-center">
                                            <img src={slotSelected} alt="" />
                                            <span className="ml-8px txt-600-12">
                                              {t}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}

                    {followUpDetails.time && (
                      <PrimaryButton
                        className="mb-20 mt-10"
                        onTap={() =>
                          // history.push('/lab-test/order-summary', {
                          //   cartId: this.cartId,
                          // })
                          this.selectSlot()
                        }
                      >
                        <div
                          className="txt-600-white-12"
                          style={{ textAlign: 'center' }}
                        >
                          Confirm
                        </div>
                      </PrimaryButton>
                    )}
                  </div>
                </div>
              </FlyInTransition>
            </div>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  chatInfo: state.chat,
  userId: state.user?.userId,
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(ConsultationChatOnlyContainer);
